import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "products" };
const _hoisted_2 = { class: "info-container max-width" };
const _hoisted_3 = { class: "card" };
const _hoisted_4 = { class: "content" };
const _hoisted_5 = { class: "name" };
const _hoisted_6 = { class: "text" };
const _hoisted_7 = { class: "image" };
const _hoisted_8 = ["src"];
import { ref, onMounted } from "vue";
import post from "./components/post.vue";
import { getProductList } from "@/api/products";
import aboutImg from "@/assets/image/about.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const postRef = ref();
        const clickCount = ref(0);
        const productList = ref([]);
        const refreshData = async () => {
            try {
                const res = await getProductList();
                productList.value = res.data;
            }
            catch {
                // 暂无产品
            }
        };
        onMounted(() => {
            refreshData();
        });
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show();
                clickCount.value = 0;
            }
        };
        return (_ctx, _cache) => {
            const _component_el_carousel_item = _resolveComponent("el-carousel-item");
            const _component_el_carousel = _resolveComponent("el-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", {
                    class: "top-container",
                    onClick: handleEdit
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "en-title" }, "PRODUCTS", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "cn-title" }, "产品展示", -1)),
                        (productList.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_el_carousel, {
                                key: 0,
                                height: "316px",
                                direction: "vertical",
                                trigger: "click",
                                interval: 5000
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                            key: item.id
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createElementVNode("div", _hoisted_4, [
                                                        _createElementVNode("h3", _hoisted_5, _toDisplayString(item.name), 1),
                                                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.content), 1),
                                                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "btn-container" }, [
                                                            _createElementVNode("div", { class: "btn" }, "产品介绍 →")
                                                        ], -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createElementVNode("img", {
                                                            src: item.image || _unref(aboutImg),
                                                            alt: "产品图片"
                                                        }, null, 8, _hoisted_8)
                                                    ])
                                                ])
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: refreshData
                }, null, 512)
            ]));
        };
    }
});
